export default {
    spa: {
        routes: [
            {
                component: 'sample',
                name: 'sample',
                path: '/*',
            },
        ],
    },
};
